import { ClientCRMRepo } from "@services/clients/clientCRM.repo";

export class AddRestrictionModalController {
    public client: any;
    public clientNumber: string;
    public restriction: any = {};
    public dropdownOptions: any = {};
    public isEditMode: boolean = false;
    public isLoading: boolean = false;
    public title: string = 'New Restriction';
    public acceptButtonText: string = 'Save';
    public cancelButtonText: string = 'Cancel';
    public clientPortfolioAccounts: any[] = [];

    /** @ngInject */
    constructor(
        private $mdDialog: angular.material.IDialogService,
        private clientCRMRepo: ClientCRMRepo
    ) {}

    public $onInit(): void {
        // Check if we're in edit mode
        this.isEditMode = this.restriction && this.restriction.id ? true : false;
        
        if (this.isEditMode) {
            this.title = 'Edit Restriction';
        } else {
            // Initialize with default values for new restriction
            this.restriction = {
                portfolioNumber: '',
                assetClass: undefined,
                nameOfPosition: '',
                startDate: undefined,
                endDate: undefined
            };
        }

        // Load client portfolio accounts
        this.loadClientPortfolioAccounts();
    }

    private loadClientPortfolioAccounts(): void {
        if (this.clientNumber) {
            this.isLoading = true;
            this.clientCRMRepo.getClientPortfolioAccounts(this.clientNumber)
                .then((response: any) => {
                    this.clientPortfolioAccounts = response.data || [];
                })
                .catch((error) => {
                    console.error('Error loading client portfolio accounts:', error);
                    this.clientPortfolioAccounts = [];
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }

    public save(): void {
        // Validate required fields
        if (!this.restriction.portfolioNumber) {
            console.log('Error: Portfolio number is required');
            return;
        }

        if (!this.restriction.assetClass) {
            console.log('Error: Asset class is required');
            return;
        }

        if (!this.restriction.nameOfPosition) {
            console.log('Error: Name of position is required');
            return;
        }

        this.$mdDialog.hide(this.restriction);
    }

    public cancel(): void {
        this.$mdDialog.cancel();
    }
}

export const AddRestrictionModalComponent: angular.IComponentOptions = {
    template: require('./add-restriction-modal.html'),
    controller: AddRestrictionModalController,
    controllerAs: '$ctrl',
    bindings: {
        client: '<',
        restriction: '=',
        dropdownOptions: '<',
        clientPortfolioAccounts: '<',
        clientNumber: '<'
    }
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.details/portfolio/modals/add-restriction-modal.ts